import React from 'react';
// import {
//     Grid,
//     Input,
//     MenuItem,
//     FormControl,
//     InputLabel,
//     Select
// } from "@material-ui/core";
import Grid from '@material-ui/core/Grid';
import Button from "components/CustomButtons/Button.jsx";
// import classNames from "classnames";
import withStyles from "@material-ui/core/styles/withStyles";
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
// import StepButton from '@material-ui/core/StepButton';
// import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import StepLabel from '@material-ui/core/StepLabel';
import AirlineSelect from './steps/Airline';
import AirportsSelect from './steps/Airports';
import PullManifestSelect from './steps/PullManifest';
import CompletedIcon from "@material-ui/icons/Check";
import { AlertBar } from "../../utils/AlertBar";
import { alertActions } from '../../_actions';
import { connect } from "react-redux";
import {commonService} from "../../_services";
import {appConstants} from "../../_constants";

const styles = theme => ({
    container: {
        display: "flex",
        flexWrap: "wrap"
    },
    input: {
        marginTop: "0 !important"
    },
    nb: {
        color: "red",
        fontSize: "12px"
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: "67%"
    },
    root: {
        flexGrow: 1
    },
    paper: {
        padding: theme.spacing.unit * 2,
        textAlign: "center",
        color: theme.palette.text.secondary
    },
    formRoot: {
        display: "flex",
        flexWrap: "wrap"
    },
    formControl: {
        margin: theme.spacing.unit,
        minWidth: 120,
        width: "100%"
    },
    selectEmpty: {
        marginTop: theme.spacing.unit * 2
    },
    searchButton: {
        backgroundColor: " #66bb6a"
    },
    selectInput: {
        marginTop: "0px",
        width: '100%'
    },
    instructions: {
        marginTop: theme.spacing.unit,
        marginBottom: theme.spacing.unit,
    },
    completed: {
        display: 'inline-block',
    },
    stepper: {
        iconColor: 'green' // or logic to change color
    },
    center: {
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        height: '100%'
    },
});

class HorizontalLabelPositionBelowStepper extends React.Component {
    state = {
        activeStep: 0,
        selectedRoutes: [],
        steps: ['Select Airline', 'Pull Manifest?', 'Add Routes'],
        Destination: '-1',
        Departure: '-1',
        AirlineId: '-1',
        pullManifestStatuses: [
            { Id: '1', Name: 'Yes' },
            { Id: '2', Name: 'No' }
        ],
        IsPullManifest: "1",
        error: false,
        pageSize: 10,
        currentPage: 1,
        totalCount: 0,
        from: 1,
        previousRoutes: [],
        fetchingPreviousRoutes: false
    };

    handleNext = () => {
        //validate current step
        const error = this.validateStepForm(this.state.activeStep);
        if (!error) {
            this.setState(state => ({
                activeStep: state.activeStep + 1,
                error: false
            }), () => {
                if (this.state.activeStep === 2) {
                    this.getAllRoutes();
                }
            });
        } else {
            this.setState({ error })
        }

    };

    filterAirports = (airportCode) => {
        let {airports} = this.props;

        let result = airports.find(item => item.Code === airportCode);

        if (result === undefined) {
            result = {Name: airportCode, Code: airportCode}
        }

        return result
    }

    getAllRoutes = (pageNumber = 1) => {
        const { dispatch } = this.props;
        const { pageSize, AirlineId } = this.state;
        const payload = {
            AirlineId: AirlineId,
            Size: pageSize,
            From: pageNumber
        };
        dispatch(alertActions.startRequest());
        this.setState({fetchingPreviousRoutes: true})
        commonService.searchAirlineRoute(payload)
            .then((res) => {
                dispatch(alertActions.stopRequest());
                let response = res.response;
                if(res.status === appConstants.SUCCESS_RESPONSE) {
                    this.setState({
                        TotalCount: response.TotalCount,
                        previousRoutes: response.AirlineRoute,
                        fetchingPreviousRoutes: false,
                        // viewModal: true,
                        from: pageNumber
                    }, () => {
                        if (this.state.previousRoutes !== []) {
                            this.addPreviousRoute();
                        }
                    })
                }
                else if(res.status === appConstants.ERROR_RESPONSE){
                    dispatch(alertActions.error(res.response));
                }
            });
    };

    addPreviousRoute = () => {
        let {previousRoutes} = this.state;
        let uniqueId = new Date().getTime();

        let modifiedPreviousRoutes;
            modifiedPreviousRoutes = [...previousRoutes];
            modifiedPreviousRoutes.map(item => {
                if (item.DepartureCode) {
                    item.Departure = this.filterAirports(item.DepartureCode)
                }
                if(item.DestinationCode) {
                    item.Destination = this.filterAirports(item.DestinationCode)
                }
                item.Id_ = uniqueId++;
                return item;
            });
        // console.log({modifiedPreviousRoutes});

        this.setState({selectedRoutes: modifiedPreviousRoutes})
    };

    validateStepForm = (step) => {
        const { AirlineId } = this.state;
        switch (step) {
            case 0:
                return (AirlineId === "-1") ? 'Please select airline' : false;
            default:
                return false;
        }
    }

    handleBack = () => {
        this.setState(state => ({
            activeStep: state.activeStep - 1,
        }), () => {
            if ( this.state.activeStep === 1) {
                this.setState({selectedRoutes: []})
            }
        });
    };

    handleReset = () => {
        this.setState({
            activeStep: 0,
        });
    };

    saveChanges = () => {
        const { selectedRoutes, AirlineId, IsPullManifest } = this.state;
        const { user } = this.props;

        let Routes = [];
        for (let item of selectedRoutes) {
            Routes.push({
                DepartureCode: item.Departure.Code,
                DestinationCode: item.Destination.Code
            })
        }
        let payload = {
            AirlineId,
            IsPullManifest: (IsPullManifest === '1'),
            CreatedBy: user.userId,
            Routes
        };

        this.props.handleCreateRoute(payload);
    };

    handleChange = (event) => {
        this.setState({ [event.target.name]: event.target.value })
    };

    handleReactSelectChange = (value, name) => {
        this.setState({[name.name]: value.value})
    };

    addSelectedRoute = () => {
        const { dispatch } = this.props
        let { Departure, Destination, selectedRoutes } = this.state;

        if (Departure === "-1" || Destination === "-1") {
            dispatch(alertActions.error("Please select required fields"));
            return;
        }
        if (Departure.Name.toLowerCase() === Destination.Name.toLowerCase()) {
            dispatch(alertActions.error("Departure route and destination route cannot be the same"));
            return;
        }
        const Id_ = new Date().getTime();
        selectedRoutes = [...selectedRoutes, { Id_, Departure, Destination }];
        this.setState({ selectedRoutes, Departure: "-1", Destination: "-1" });
    };

    removeSelectedRoute = (id) => {
        // console.log('selectedRoutes', this.state.selectedRoutes);
        let filterRoutes = this.state.selectedRoutes.filter(item => item.Id_ !== id);
        // console.log({filterRoutes});
        this.setState({ selectedRoutes: filterRoutes });
    }


    getStepContent = (step) => {
        const { airlines, airports } = this.props;
        const { selectedRoutes, Destination, Departure, AirlineId, pullManifestStatuses, IsPullManifest, fetchingPreviousRoutes } = this.state;
        switch (step) {
            case 0:
                return (<AirlineSelect selectChange={this.handleReactSelectChange} AirlineId={AirlineId} airlines={airlines} />);
            case 1:
                return (<PullManifestSelect selectChange={this.handleChange} IsPullManifest={IsPullManifest} pullManifestStatuses={pullManifestStatuses} />);
            case 2:
                return (<AirportsSelect addSelectedRoute={this.addSelectedRoute}
                                        removeSelectedRoute={this.removeSelectedRoute}
                                        selectChange={this.handleReactSelectChange}
                                        selectedRoutes={selectedRoutes}
                                        airports={airports}
                                        Departure={Departure}
                                        Destination={Destination}
                                        disabled={this.props.requesting}
                                        fetchingPreviousRoutes={fetchingPreviousRoutes}
                />);
            default:
                return 'Unknown step';
        }
    }


    render() {
        const { classes, requesting } = this.props;
        const { activeStep, steps, error } = this.state;

        return (
            <div className={classes.root}>
                <Stepper activeStep={activeStep}>
                    {steps.map(label => (
                        <Step key={label}>
                            <StepLabel>{label}</StepLabel>
                        </Step>
                    ))}
                </Stepper>
                <Grid container style={styles.center}>
                    <Grid item lg={3} sm={12}>
                        &nbsp;
                    </Grid>
                    <Grid item lg={6} sm={12}>
                        {
                            error &&
                            <AlertBar message={error} />
                        }
                    </Grid>
                </Grid>
                <div>
                    {this.state.activeStep === steps.length ? (
                        <div>
                            <h1 className={'text-center text-primary'} style={{ lineHeight: 0, margin: 0 }}>
                                <CompletedIcon style={{ fontSize: '60px' }} />
                            </h1>
                            <p className={'text-center'}>
                                All steps completed.
                            </p>
                            <div style={{ textAlign: 'center', margin: 0 }}>
                                <Button disabled={requesting} color="primary" onClick={this.saveChanges}>
                                    Save Changes
                                </Button>
                            </div>
                            <Button onClick={this.handleReset} size={'sm'}>
                                Go Back
                            </Button>
                        </div>
                    ) : (
                            <div style={{ paddingLeft: '18px' }}>
                                <Typography className={classes.instructions}>{this.getStepContent(activeStep)}</Typography>
                                <div>
                                    <Button
                                        disabled={activeStep === 0}
                                        onClick={this.handleBack}
                                        className={classes.backButton}
                                        size={'sm'}
                                    >
                                        Back
                                </Button>
                                    &nbsp;
                                <Button variant="contained" size={'sm'} color="primary" onClick={this.handleNext}>
                                        {activeStep === steps.length - 1 ? 'Finish' : 'Next'}
                                    </Button>
                                </div>
                            </div>
                        )}
                </div>
            </div>
        )
    }
}

function mapStateToProps(state, ownProps) {
    const { alert, requesting} = state;
    return {
        alert,
        requesting
    };
}
export default connect(mapStateToProps)(withStyles(styles)(HorizontalLabelPositionBelowStepper));



// WEBPACK FOOTER //
// ./src/views/AirlineRouteSettings/RouteFormPanel.js